import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

import { api } from '../api.js';
import StatusBadge from './StatusBadge.jsx';

// Dashboard: Übersicht über Kennzahlen und jüngste Ereignisse.
// Tickets gibt es nicht mehr – ihre Rolle wird durch den Status auf
// Ereignissen abgebildet.
export default function Dashboard() {
    const navigate = useNavigate();
    const [mandanten, setMandanten] = useState([]);
    const [events, setEvents] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    useEffect(() => {
        let cancelled = false;
        (async () => {
            try {
                const [m, e] = await Promise.all([api.listMandanten(), api.listEvents()]);
                if (cancelled) return;
                setMandanten(m);
                setEvents(e);
            } catch (err) {
                if (!cancelled) setError(err.message);
            } finally {
                if (!cancelled) setLoading(false);
            }
        })();
        return () => {
            cancelled = true;
        };
    }, []);

    if (loading) return <div className="empty">Lade…</div>;
    if (error) return <div className="empty">Fehler: {error}</div>;

    const openEvents = events.filter((e) => e.status === 'offen');
    const inProgressEvents = events.filter((e) => e.status === 'in Arbeit');
    const activeMandanten = mandanten.filter((m) => Number(m.active) === 1);
    const lastEvents = events.slice(0, 5);
    const openEventsTop = openEvents.slice(0, 10);

    return (
        <div>
            <h1>Dashboard</h1>

            <div className="metrics">
                <Metric label="Mandanten (aktiv)" value={activeMandanten.length} />
                <Metric label="Ereignisse" value={events.length} />
                <Metric label="Ereignisse (offen)" value={openEvents.length} />
                <Metric label="Ereignisse (in Arbeit)" value={inProgressEvents.length} />
            </div>

            <div className="panel">
                <h2>Letzte Ereignisse</h2>
                {lastEvents.length === 0 ? (
                    <div className="empty">Keine Ereignisse vorhanden.</div>
                ) : (
                    <div className="table-wrap">
                        <table>
                            <thead>
                                <tr>
                                    <th>Titel</th>
                                    <th>Mandant</th>
                                    <th>Status</th>
                                    <th>Autor</th>
                                    <th>Datum</th>
                                </tr>
                            </thead>
                            <tbody>
                                {lastEvents.map((e) => (
                                    <tr
                                        key={e.id}
                                        className="row-clickable"
                                        onClick={() => navigate(`/events/${e.id}`)}
                                    >
                                        <td>{e.title}</td>
                                        <td>{e.mandant_name || <span className="muted">–</span>}</td>
                                        <td><StatusBadge status={e.status} /></td>
                                        <td>{e.author || <span className="muted">–</span>}</td>
                                        <td>{formatDate(e.created_at)}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                )}
                <div style={{ marginTop: 8 }}>
                    <Link to="/events">Alle Ereignisse →</Link>
                </div>
            </div>

            <div className="panel">
                <h2>Offene Ereignisse</h2>
                {openEventsTop.length === 0 ? (
                    <div className="empty">Keine offenen Ereignisse.</div>
                ) : (
                    <div className="table-wrap">
                        <table>
                            <thead>
                                <tr>
                                    <th>Titel</th>
                                    <th>Mandant</th>
                                    <th>Autor</th>
                                    <th>Erstellt</th>
                                </tr>
                            </thead>
                            <tbody>
                                {openEventsTop.map((e) => (
                                    <tr
                                        key={e.id}
                                        className="row-clickable"
                                        onClick={() => navigate(`/events/${e.id}`)}
                                    >
                                        <td>{e.title}</td>
                                        <td>{e.mandant_name || <span className="muted">–</span>}</td>
                                        <td>{e.author || <span className="muted">–</span>}</td>
                                        <td>{formatDate(e.created_at)}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                )}
            </div>
        </div>
    );
}

function Metric({ label, value }) {
    return (
        <div className="metric">
            <div className="metric__label">{label}</div>
            <div className="metric__value">{value}</div>
        </div>
    );
}

function formatDate(s) {
    if (!s) return '';
    const iso = s.replace(' ', 'T') + 'Z';
    const d = new Date(iso);
    if (isNaN(d.getTime())) return s;
    return d.toLocaleString('de-DE');
}
